export const AlertCardDefProps = {
  alert: {
    type: 'WARNING',
    text: 'Вы внесли изменения в данные контракта. Не забудьте сохранить их!'
  }
};